const {Component} = require("react");
const PropTypes = require("prop-types");
const {numberFormat} = require("app/util/formaters");
const browser = require("app/services/browser");
const PriceOption = require("./PriceOption")
const Trans = require('app/components/trans/Trans');

class PriceWidget extends Component {

    static get propTypes() {
        return {
            default: PropTypes.number.isRequired,
            values: PropTypes.array,
            custom: PropTypes.object,
            onChange: PropTypes.func
        };
    }

    static get defaultProps() {
        return {
            values: [],
            custom: null
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            value: props.default,
            option: props.default.toString(),
            animation: null
        };
    }

    get className() {
        let classList = ["price-widget"];

        if ((this.props.values.length > 1) || (this.props.custom)) {
            classList.push("has-options");
        }

        return classList.join(" ");
    }

    get value() {
        return this.state.value;
    }

    triggerChange(value) {
        if (typeof this.props.onChange === "function") {
            return this.props.onChange(value);
        }
    }

    reset() {
        if (this.selectElement) {
            this.selectElement.value = this.props.default.toString();
        }

        this.setState({
            value: this.props.default,
            option: this.props.default.toString()
        });
    }

    setValue(value) {
        this.setState({value});
    }

    normalizeCustomValue(value) {
        if (this.props.custom == undefined) {
            return value;
        }

        if (value < this.props.custom.min) {
            return this.props.custom.min;
        }

        if (value > this.props.custom.max) {
            return this.props.custom.max;
        }

        return value;
    }

    _onOptionChange = () => {
        // Determine value
        let value;

        value = this.normalizeCustomValue(Math.round(this.state.value * 1.2));

        this.setState({
            option: this.selectElement.value
        });

        this.animatePriceTo(value).then(() => {
            this.triggerChange(value);

            setTimeout(() => {
                if (this.customPriceField && !browser.ios()) {
                    this.customPriceField.element.focus();
                }

            }, 50);
        });
    };

    _onOptionChangeNew = (e) => {
        // Determine value
        let value;

        this.stopPriceAnimation();
        value = parseFloat(e.target.value);

        this.setState({
            option: e.target.value,
        });

        this.animatePriceTo(value).then(() => {
            this.triggerChange(value);
        });
    };

    _onCustomChange = () => {
        const value = this.normalizeCustomValue(this.customPriceField.numericValue);

        // Polyfill for isNaN
        if (value === value) {
            this.customPriceField.value = value;
            this.setState({value});
        }
        else {
            this.customPriceField.value = this.state.value;
        }
    };

    animatePriceTo(to_value, duration = 500) {
        return new Promise(resolve => {

            const current = this.state.value;

            const difference = Math.abs(to_value - current);
            let direction = to_value - current > 0 ? 1 : -1;

            if (difference === 0) {
                return resolve();
            }

            let currentStep = current;

            let duration_per_unit = difference / duration;
            let step_duration = 20;
            let increment_per_step = step_duration * duration_per_unit;

            this.setState({
                animation: setInterval(() => {

                    // Round increment to 2 decimal
                    currentStep += Math.ceil(direction * increment_per_step);

                    let has_reached_end = ((direction > 0) ? currentStep >= to_value : currentStep <= to_value);

                    if (has_reached_end) {

                        this.setState({
                            value: to_value
                        });

                        this.stopPriceAnimation();
                        resolve();
                    } else {
                        this.setState({
                            value: currentStep
                        });
                    }

                }, step_duration)
            });
        });
    }

    stopPriceAnimation() {
        if (this.state.animation) {
            clearInterval(this.state.animation);
            this.setState({animation: null});
        }
    }

    renderSelectorOptions() {
        let options = [];

        this.props.values.forEach((value, i) => {
            options.push(<option key={i} value={value}>{numberFormat(value)}</option>);
        });

        if (this.props.custom) {
            options.push(<option key="custom" value="custom">Egen Pris</option>);
        }

        return options;
    }

    renderSelector() {
        if ((this.props.values.length <= 1) && !this.props.custom) {
            return;
        }

        return (
            <select ref={el => this.selectElement = el}
                    onChange={this._onOptionChange}
                    defaultValue={this.state.option}>{this.renderSelectorOptions()}</select>
        );
    }

    renderNormalPrice() {
        return (
            <span className="value">{numberFormat(this.state.value)}</span>
        );
    }

    renderOptionsNew () {
        return (
            this.props.values.map(value => 
                <PriceOption key={value} onClick={this._onOptionChangeNew} value={value} name="price-radio-input" defaultChecked={value == this.state.option}>
                    {numberFormat(value)}
                </PriceOption>
            )
        )
    }

    render() {
        return (
            <div className={this.className}>
                <div className="product-configurator-info">
                    <div className="product-configurator-info__row">
                        <div>
                            <span className="product-configurator-info__text"><Trans>Valgt pris: </Trans></span>
                        </div>
                        <div className="product-configurator-info__title">{this.renderNormalPrice()}</div>
                    </div>
                </div>
                {this.props.values.length > 1 && (
                    <div className='price-radio-wrap'>
                        {this.renderOptionsNew()}
                    </div>
                )}
                <div style={{display:'none'}}>{this.renderSelector()}</div>
                <button onClick={this.props.onClick} className="btn primary"><Trans>Læg i kurven</Trans></button>
            </div>
        );
    }

}

module.exports = PriceWidget;
